import {Button, Divider, Form, Input, message, Space} from 'antd';
import {FC, useEffect, useState} from 'react';
import {DEFAULT_API_NAME, useApi} from '../../util/Auth';
import {showModal} from '../AwaitableModal';
import {FormSubmitButton} from '../FormSubmitButton';

const SuperAdminDevTestRoute: FC = (props) => {
  const api = useApi();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState<string>();

  return (
    <div>
      <Form
        initialValues={{
          body: JSON.stringify({
            action: 'test-mail1',
          }),
        }}
        onFinish={async (values) => {
          if (loading || !values.body || !api) {
            return;
          }

          await showModal('confirm', {
            title: 'Envoyer cette requête de test?',
            content: <p>{values.body}</p>,
          });

          setError('');
          setLoading(true);
          try {
            const res = await api.post(
              DEFAULT_API_NAME,
              `/super-admin/test-route`,
              {
                body: JSON.parse(values.body),
              },
            );

            if (!res) {
              throw new Error('Error');
            }

            if (!!res.error) {
              throw new Error(res.error);
            }

            setInfo(res);
          } catch (err: any) {
            const msg = err.response?.data ?? err?.message ?? err;
            message.warning(msg);
            setInfo(undefined);
            setError(msg);
          }
          setLoading(false);
        }}
      >
        <Form.Item label="Body (json)" name="body">
          <Input.TextArea />
        </Form.Item>
        <FormSubmitButton>Send</FormSubmitButton>
      </Form>

      {error}

      {info ? <div>{JSON.stringify(info)}</div> : undefined}
    </div>
  );
};

export const SuperAdminDev: FC = (props) => {
  // Several ways to make the React app error, mainly to test
  // AppErrorBoundary & GlobalErrorListener components.
  const [triggerTest1, setTriggerTest1] = useState(false);
  if (triggerTest1) {
    throw new Error('error: testing ErrorBoundary');
  }

  const [triggerTest2, setTriggerTest2] = useState(false);
  useEffect(() => {
    if (triggerTest2) {
      setTimeout(() => {
        throw new Error('error: testing window.onerror');
      }, 0);
    }
  }, [triggerTest2]);

  const [triggerTest3, setTriggerTest3] = useState(false);
  useEffect(() => {
    if (triggerTest3) {
      Promise.reject(new Error('error: testing unhandledrejection'));
    }
  }, [triggerTest3]);

  return (
    <div>
      <Divider>Call test route</Divider>
      <SuperAdminDevTestRoute />

      <Divider>Errors trigger</Divider>
      <Space>
        <Button onClick={() => setTriggerTest1(true)}>
          Test ErrorBoundary
        </Button>
        <Button onClick={() => setTriggerTest2(true)}>
          Test window.onerror
        </Button>
        <Button onClick={() => setTriggerTest3(true)}>
          Test unhandledrejection
        </Button>
      </Space>
    </div>
  );
};
